import { DecisionContext, DecisionTypeHandler, DbotEventDispatcher } from "../common/commonDomain";
import { ApproveAnnualAccount, ApproveAnnualAccountForm } from "./approveAnnualAccountDomain";
import { DecisionType } from "../../common/decisions";

export function initNewForm(
  _: DbotEventDispatcher,
  context: DecisionContext,
  data?: ApproveAnnualAccount,
): ApproveAnnualAccountForm {
  return new ApproveAnnualAccountForm(context, data);
}

export function isValid(form: ApproveAnnualAccountForm): boolean {
  return form.isValid;
}

export function validate(form: ApproveAnnualAccountForm): boolean {
  return form.validate();
}

export function applyForm(form: ApproveAnnualAccountForm): ApproveAnnualAccount {
  return {
    type: DecisionType.approveAnnualAccount,
    isDeviatingPeriod: form.isDeviatingPeriod.value,
    deviatingPeriodFrom: form.deviatingPeriodFrom.toISOString(),
    deviatingPeriodTo: form.deviatingPeriodTo.toISOString(),
    period: form.period.parsedValue?.toString(),
    isSmallBusinesses: form.isSmallBusinesses.value,
    isGroup: form.isGroup.value,
  };
}

export const approveAnnualAccountHandler: DecisionTypeHandler<
  DecisionType.approveAnnualAccount,
  ApproveAnnualAccount,
  ApproveAnnualAccountForm
> = {
  type: DecisionType.approveAnnualAccount,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
